// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1__fc20767adb4d43df3624","cls2":"Header-cls2___39bf8eb08ed2ef758ac Header-cls1__fc20767adb4d43df3624","small":"Header-small___ff307bfa9aec261128b"};